import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

interface DataPoint { date: string; tokens: number; }
interface Payload { series?: DataPoint[]; }

const MOCK: DataPoint[] = [
  { date: 'Пн', tokens: 1200 }, { date: 'Вт', tokens: 3400 },
  { date: 'Ср', tokens: 2100 }, { date: 'Чт', tokens: 4500 },
  { date: 'Пт', tokens: 3200 }, { date: 'Сб', tokens: 1800 },
  { date: 'Вс', tokens: 900 },
];

export default function UsageChart({ data }: { data: unknown }) {
  const series = ((data ?? {}) as Payload).series ?? MOCK;
  const wrapSt: React.CSSProperties = { height: '100%', display: 'flex', flexDirection: 'column' };
  const lblSt:  React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', marginBottom: 6, margin: 0 };
  const chartSt: React.CSSProperties = { flex: 1, minHeight: 0 };
  const tick = { fontSize: 10, fill: 'var(--tg-theme-hint-color)' };
  const tooltipStyle = {
    background: 'var(--tg-theme-secondary-bg-color)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8, fontSize: 12,
    color: 'var(--tg-theme-text-color)',
  };
  const margin = { top: 4, right: 4, left: -24, bottom: 0 };
  const cursorStyle = { fill: 'rgba(255,255,255,0.05)' };
  return (
    <div style={wrapSt}>
      <p style={lblSt}>Токены / день</p>
      <div style={chartSt}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={series} margin={margin}>
            <XAxis dataKey="date" tick={tick} axisLine={false} tickLine={false} />
            <YAxis tick={tick} axisLine={false} tickLine={false} />
            <Tooltip contentStyle={tooltipStyle} cursor={cursorStyle} />
            <Bar dataKey="tokens" fill="var(--tg-theme-button-color)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
